import { logger } from '#pplx/frontend/logger/browser.js';
/**
 * Get the Cloudflare trace from the CF. This is something like
 * ```
 * fl=1005f5
h=www.perplexity.ai
ip=2600:1017:b8b7:462f:9d89:eb3f:12dd:88bc
ts=1748109443.303
visit_scheme=https
uag=Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36
colo=EWR
sliver=none
http=http/2
loc=US
tls=TLSv1.3
sni=plaintext
warp=off
gateway=off
rbi=off
kex=X25519MLKEM768
```
 * @returns The Cloudflare trace
 */
export async function getCloudflareTrace() {
    try {
        const resp = await fetch('/cdn-cgi/trace');
        const respText = await resp.text();
        return respText.split('\n').reduce((acc, line) => {
            const [key, value] = line.split('=');
            acc[key] = value ?? '';
            return acc;
        }, {
            loc: 'US',
        });
    }
    catch (e) {
        logger.error('Error getting Cloudflare trace', e);
        return { loc: 'US' };
    }
}
//# sourceMappingURL=getCloudflareTrace.js.map